var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.iconUrl && _vm.iconUrlFound)?_c('img',{staticClass:"i",class:{
    [_vm.name]: _vm.isFontFullName,
    [`${_vm.prefix}-${_vm.name}--${_vm.computedVariant}`]: _vm.name && _vm.variant && !_vm.isFontFullName,
    'is-disabled': _vm.disabled,
    'is-right': _vm.right,
    'is-left': _vm.left
  },attrs:{"src":_vm.iconUrl,"width":_vm.variant,"alt":"Icon"},on:{"error":_vm.onIconError,"click":_vm.click}}):(!_vm.legacy)?_c('i',{staticClass:"i is-latest qa-icon",class:{
    [_vm.name]: _vm.isFontFullName,
    [`${_vm.prefix}-${_vm.name}--${_vm.computedVariant}`]: _vm.name && _vm.variant && !_vm.isFontFullName,
    [`${_vm.prefix}--size-${_vm.computedSize}`]: _vm.size || _vm.variant,
    [`${_vm.prefix}--color-${_vm.color}`]: _vm.color,
    'is-disabled': _vm.disabled,
    'is-right': _vm.right,
    'is-left': _vm.left,
    'is-multi-color': _vm.isMultiColor
  },on:{"click":_vm.click}},[(_vm.state)?_c('i',{staticClass:"i__state is-latest qa-icon-state",class:{
      [_vm.state]: _vm.state,
      [`${_vm.prefix}--size-${_vm.computedSize}`]: _vm.size || _vm.variant,
      [`${_vm.prefix}--color-${_vm.color}`]: _vm.color,
      'is-disabled': _vm.disabled,
      'is-multi-color': _vm.isStateMultiColor
    }},[_c('svg',{staticClass:"svg qa-svg",class:{
        [`svg--size-${_vm.computedSize}`]: _vm.size || _vm.variant,
      }},[_c('use',_vm._b({},'use',{ 'xlink:href': _vm.statePath, 'href': _vm.statePath },false))])]):_vm._e(),_vm._v(" "),_c('svg',{staticClass:"svg qa-svg",class:{
      [`svg--size-${_vm.computedSize}`]: _vm.size || _vm.variant,
    }},[_c('use',_vm._b({},'use',{ 'xlink:href': _vm.iconPath, 'href': _vm.iconPath },false))])]):(!_vm.isSvgIcon)?_c('i',{staticClass:"i qa-icon",class:{
    [_vm.name]: _vm.isFontFullName,
    [`${_vm.prefix}-${_vm.name}--${_vm.computedVariant}`]: _vm.name && _vm.variant && !_vm.isFontFullName,
    [`${_vm.prefix}--size-${_vm.computedSize}`]: _vm.size || _vm.variant,
    [`${_vm.prefix}--color-${_vm.color}`]: _vm.color,
    'is-disabled': _vm.disabled,
    'is-right': _vm.right,
    'is-left': _vm.left
  },on:{"click":_vm.click}},[(_vm.state)?_c('i',{staticClass:"i__state qa-icon-state",class:{
      [_vm.state]: _vm.state,
      [`${_vm.prefix}--size-${_vm.computedSize}`]: _vm.size || _vm.variant,
      [`${_vm.prefix}--color-${_vm.color}`]: _vm.color,
      'is-disabled': _vm.disabled
    }}):_vm._e()]):_c('svg',{key:_vm.svgIconPath,staticClass:"svg qa-svg",class:{
    [_vm.name]: _vm.isFontFullName,
    [`svg-${_vm.name}--${_vm.computedVariant}`]: _vm.name && _vm.variant && !_vm.isFontFullName,
    [`svg--size-${_vm.computedSize}`]: _vm.size || _vm.variant
  }},[_c('use',_vm._b({},'use',{ 'xlink:href': _vm.svgIconPath, 'href': _vm.svgIconPath },false))])
}
var staticRenderFns = []

export { render, staticRenderFns }